'use strict';

module.exports = global;



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/implementation.js
 ** module id = 1114
 ** module chunks = 0
 **/